import { render, staticRenderFns } from "./switchLockRecord.vue?vue&type=template&id=5bd4edfd&scoped=true&"
import script from "./switchLockRecord.vue?vue&type=script&lang=js&"
export * from "./switchLockRecord.vue?vue&type=script&lang=js&"
import style0 from "./switchLockRecord.vue?vue&type=style&index=0&id=5bd4edfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4edfd",
  null
  
)

export default component.exports